import http from 'hub-http/clients/apiClient';
import { useState, useEffect, useMemo } from 'react';
export const useDeepLSupportedLanguages = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  useEffect(() => {
    setLoading(true);
    http.get('/auto-translator/translate/languages').then(response => {
      setData(response);
      setError(null);
    }).catch(err => {
      setError(err);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  return useMemo(() => ({
    loading,
    error,
    sourceLanguages: (data === null || data === void 0 ? void 0 : data.sourceLanguages) || [],
    targetLanguages: (data === null || data === void 0 ? void 0 : data.targetLanguages) || []
  }), [loading, error, data]);
};